// A short, visible reminder for an active delivery which needs immediate attention.
export function scheduleAttention(booking, now = Date.now()) {
  const finished = ['DELIVERED', 'COMPLETED', 'CANCELLED'].includes(booking.deliveryStatus)
    || ['RECEIVED', 'COMPLETED', 'CANCELLED'].includes(booking.returnStatus);
  if (finished) return '';
  if (booking.deliveryNeedsReassignment) return 'Reassignment needed';
  if (!booking.deliveryAssignment?.assignedTo) return 'Assignment needed';
  const scheduledAt = new Date(booking.deliveryAssignment.scheduledAt).getTime();
  const notStarted = !booking.deliveryStatus || booking.deliveryStatus === 'PENDING';
  if (!notStarted || !Number.isFinite(scheduledAt)) return '';
  if (scheduledAt < now) return 'Late — not started';
  if (scheduledAt - now <= 60 * 60 * 1000) return 'Due within 1 hour';
  return '';
}
